export const OPCOES_DESTAQUES_PRODUTO = [
  { code: 'NOVIDADE', label: 'Novidade', description: 'Uma novidade no cardápio' },
  { code: 'RECOMENDADO', label: 'Recomendado', description: 'Uma sugestão da casa' },
  { code: 'FAVORITO', label: 'Favorito', description: 'Um dos favoritos da casa' },
  { code: 'VEGANO', label: 'Vegano', description: 'Sem ingredientes de origem animal' },
  { code: 'VEGETARIANO', label: 'Vegetariano', description: 'Sem qualquer tipo de carne' },
  { code: 'ZERO_LACTOSE', label: 'Zero Lactose', description: 'Sem lactose' },
  { code: 'ZERO_ACUCAR', label: 'Zero Açúcar', description: 'Sem açúcar' },
  { code: 'ORGANICO', label: 'Orgânico', description: 'Produzido com ingredientes orgânicos' },
  { code: 'BEBIDA_GELADA', label: 'Bebida Gelada', description: 'Servida gelada' },
  { code: 'BEBIDA_ALCOOLICA', label: 'Bebida Alcoólica', description: 'Contém álcool' },
  { code: 'NATURAL', label: 'Natural', description: 'Preparado com frutas frescas' },
] as const;

export type DestaqueProduto = typeof OPCOES_DESTAQUES_PRODUTO[number]['code'];

export function normalizarDestaquesProduto(value: unknown): DestaqueProduto[] {
  const selecionados = new Set(Array.isArray(value) ? value : []);
  return OPCOES_DESTAQUES_PRODUTO.filter(opcao => selecionados.has(opcao.code)).map(opcao => opcao.code);
}
